import React, { useEffect, useRef } from 'react';
import { volume4CarouselHtml } from '../data/volume4CarouselEmbed';

/** Real page images for the preview. The paste-ready snippet keeps the slide-0X.webp placeholders. */
const slideUrls: Record<string, string> = {
  'slide-01.webp': 'https://cdn.magicpatterns.com/uploads/oa8C2vm6yaKE3J8y3MfCbQ/slide-01.webp',
  'slide-02.webp': 'https://cdn.magicpatterns.com/uploads/4ahanEGBycubGpfMNq6Qy2/slide-02.webp',
  'slide-03.webp': 'https://cdn.magicpatterns.com/uploads/wv7Yqj2YYPgSgP8wHQ6YM9/slide-03.webp',
  'slide-04.webp': 'https://cdn.magicpatterns.com/uploads/mZ1FtyPHEeXVPCrZVHAobs/slide-04.webp',
  'slide-05.webp': 'https://cdn.magicpatterns.com/uploads/kWgLJ6ExgNTyoR4hriUQ4E/slide-05.webp',
  'slide-06.webp': 'https://cdn.magicpatterns.com/uploads/1Qxq3VjV7MUqNMb99gmVqL/slide-06.webp',
  'slide-07.webp': 'https://cdn.magicpatterns.com/uploads/r5MoeLSf7FCCB1brxJM24c/slide-07.webp',
  'slide-08.webp': 'https://cdn.magicpatterns.com/uploads/mTKiH27hRcfdj5RtJjn96A/slide-08.webp',
  'slide-09.webp': 'https://cdn.magicpatterns.com/uploads/xsSd4UvE7wxRpMexpLvRqP/slide-09.webp'
};

/**
 * Renders the exact vanilla snippet from data/volume4CarouselEmbed.ts inside the page,
 * so what you see here is what you paste into your landing page builder.
 */
export function Volume4Preview() {
  const hostRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;
    const html = volume4CarouselHtml.replace(/'slide-0\d\.webp'/g, match => {
      const key = match.slice(1, -1);
      return `'${slideUrls[key] ?? key}'`;
    });
    const template = document.createElement('template');
    template.innerHTML = html;
    const scripts = Array.from(template.content.querySelectorAll('script'));
    scripts.forEach(s => s.remove());
    host.replaceChildren(template.content);
    scripts.forEach(s => {
      const script = document.createElement('script');
      script.textContent = s.textContent;
      host.appendChild(script);
    });
    return () => {
      document.documentElement.style.overflow = '';
      host.replaceChildren();
    };
  }, []);
  return <div ref={hostRef} data-id="element-310" data-mp="19f54uqatcs6a" />;
}